const modalCallbackRegistry = {}

export default modalCallbackRegistry
